import React, { type SelectHTMLAttributes } from "react";

import { Select, type SelectProps } from "../Select";
import { countries } from "./countries";

export const CountrySelect = React.forwardRef<
  HTMLSelectElement,
  Omit<SelectHTMLAttributes<HTMLSelectElement> & SelectProps, "children">
>(({ ...attrs }, ref) => (
  <Select {...attrs} ref={ref}>
    <option value="" disabled>
      Country
    </option>
    {countries.map((country) => (
      <option key={country.code} value={country.code}>
        {country.name}
      </option>
    ))}
  </Select>
));

CountrySelect.displayName = "CountrySelect";
